<template lang="pug">
  div(class="billing-premium-label")
    e-svg-icon(
      name="lightning-primary"
      size="sm"
    )
    span(
      class="fw-500 color-primary"
      :class="[xsDevice ? 'text-12px' : 'text-14px']"
    ) Premium
</template>

<script>
import responsive from '~/mixins/pages/responsive'
export default {
  name: 'BillingPremiumLabel',
  mixins: [responsive]
}
</script>

<style scoped lang="scss">
.billing-premium-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 4px 7px;
  border-radius: 6px;
  background: linear-gradient(180deg, #fff -300%, #f8e3f4 100%);
  box-shadow:
    0px -1px 3px 0px rgba(231, 171, 221, 0.8) inset,
    0px 1px 2px 0px rgba(184, 189, 193, 0.4),
    0px 1px 1px 0px rgba(255, 255, 255, 0.7) inset;
}
</style>
